export default __webpack_public_path__ + "static/media/couple-looking-house.bd08eccd.jpg";